import { connect } from 'react-redux'
import SuccessCriteriaSlideEditDialog from './edit-dialog.jsx'
import {
  updateSlide,
  deleteSlide
} from '../../../../stores/presentation/presentation.actions'
import {
  getSlide,
  getUpdateSlideRequest,
  getDeleteSlideRequest
} from '../../../../stores/presentation/presentation.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'
import { filterCriteria } from '../helpers.js'

const mapStateToProps = state => {
  const editSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, editSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  const deleteSlideRequest = getDeleteSlideRequest(state, slide.id)
  return {
    updating: updateSlideRequest.pending,
    deleting: deleteSlideRequest.pending,
    modalOpened:
      editSlideDialog.opened && editSlideDialog.type === 'SuccessCriteria',
    title: slide.title,
    criteria: slide.criteria,
    id: slide.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'SuccessCriteria', {
        title: values.title,
        criteria: filterCriteria(values.criteria)
      })
    ).catch(errorHandler),
  onClose: () => dispatch(closeEditSlideDialog()),
  onDelete: () => dispatch(deleteSlide(stateProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SuccessCriteriaSlideEditDialog)
